import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Button, Input } from 'semantic-ui-react';
import { H1, StyledLink, LinkBlock } from '../CreateProductPage/CreateProductStyles';
import {
  SearchInputBlock,
  ButtonBlock,
  FooterBlock,
  FFLimitBlock,
  FFLimitLabel,
  GenerationModeBlock,
  GenerationModeLabel,
  CreateUserButton,
} from './userPageStyles';
import UserParamsBlock from './UserParamsBlock';
import * as action from '../../../actions/newYouslim';
import TargetedFitnessFuncBlock from './TargetedFitnessFuncBlock';
import MenuStructureBlock from './MenuStructureBlock';
import ResultBlock from './ResultBlock';
import {
  default_activity,
  default_gender,
  snackId,
  defaultGenerationModes,
  fullStructureMenuTags,
  proteinTagId,
  carbohydrateTagId,
  saladTagId,
  FruitTagId,
  vegetableTagId,
  breakfastSnackId,
  lunchSnackId,
  dinnerSnackId,
} from '../youslim2.0_Constants';
import Navbar from '../Navigation/Navbar';

const TestPage = React.memo(
  ({
    allTags,
    getProductTags,
    getUsers,
    usersGeneratedData,
    userTarget,
    users,
    updateUser,
    setUserTarget,
    getGenetatorResults,
    runGenerator,
    createUser,
    match,
  }) => {
    const [currentUser, setCurrentUser] = React.useState('');
    const [currentUserId, setCurrentUserId] = React.useState(0);
    const [choosedTags, setChoosedTags] = React.useState([]);
    const [usersList, setUsersList] = React.useState([]);
    const [isMorningSnack, setIsMorningSnack] = React.useState(true);
    const [isAfternoonSnack, setIsAfternoonSnack] = React.useState(true);
    const [isEveningSnack, setIsEveningSnack] = React.useState(false);
    const [choosedBreakfastTags, setChoosedBreakfastTags] = React.useState([
      proteinTagId,
      carbohydrateTagId,
      FruitTagId,
    ]);
    const [choosedLunchTags, setChoosedLunchTags] = React.useState([
      proteinTagId,
      carbohydrateTagId,
      vegetableTagId,
    ]);
    const [choosedDinnerTags, setChoosedDinnerTags] = React.useState([
      proteinTagId,
      carbohydrateTagId,
      saladTagId,
    ]);
    const [currentGender, setCurrentGender] = React.useState('');
    const [currentActivity, setCurrentActivity] = React.useState('');
    const [currentHeight, setCurrentHeight] = React.useState('');
    const [currentWeight, setCurrentWeight] = React.useState('');
    const [currentAge, setCurrentAge] = React.useState('');
    const [currentTargetWeight, setCurrentTargetWeight] = React.useState('');
    const [isGenerateRun, setIsGenerateRun] = React.useState(false);
    const [currentUserName, setCurrentUserName] = React.useState('');
    const [isCreateUser, setIsCreateUser] = React.useState(false);
    const [ffLimit, setFfLimit] = React.useState('');
    const [currentGenerationMode, setCurrentGenerationMode] = React.useState(1);

    React.useEffect(() => {
      getProductTags();
      getUsers();
    }, []);

    React.useEffect(() => {
      const newUsersList = [];
      users.map((user) => {
        newUsersList.push({
          key: user.id,
          text: user.name,
          value: user.name,
        });
      });
      setUsersList([...newUsersList]);
    }, [users]);

    const clearAllFields = React.useCallback(() => {
      setCurrentGender('');
      setCurrentActivity('');
      setCurrentHeight('');
      setCurrentWeight('');
      setCurrentAge('');
      setCurrentTargetWeight('');
      setChoosedTags([]);
    }, []);

    React.useEffect(() => {
      clearAllFields();
    }, [isCreateUser]);

    const onChangeUsers = (e, data) => {
      setCurrentUser(data.value);
      const user = users.find((user) => user.name === data.value);
      setCurrentUserId(user.id);
      getGenetatorResults(user.id);
      if (user.params) {
        setUserTarget(user.params);
        setChoosedTags(user.black_list_tags.map((tag) => tag.id));
        setCurrentGender(default_gender[user.params.sex_id - 1]);
        setCurrentActivity(default_activity[user.params.activity_id - 1]);
        setCurrentHeight(user.params.height);
        setCurrentWeight(user.params.weight);
        setCurrentTargetWeight(user.params.weight_target);
        setCurrentAge(user.params.age);
      } else {
        setUserTarget('');
        setChoosedTags([]);
        setCurrentGender('');
        setCurrentActivity('');
        setCurrentHeight('');
        setCurrentWeight('');
        setCurrentTargetWeight('');
        setCurrentAge('');
      }
    };

    const onParamsSave = () => {
      updateUser({
        name: currentUser,
        params: {
          sex_id: default_gender.indexOf(currentGender) + 1,
          height: currentHeight,
          weight: currentWeight,
          weight_target: currentTargetWeight,
          age: currentAge,
          activity_id: default_activity.indexOf(currentActivity) + 1,
        },
        tags: choosedTags,
        id: currentUserId,
      });
    };

    const onStartGeneration = () => {
      setIsGenerateRun(true);
      const newChoosedBreakfastTags = [];
      const newChoosedLunchTags = [];
      const newChoosedDinnerTags = [];
      fullStructureMenuTags.forEach((currentTags) => {
        choosedBreakfastTags.forEach((id) => {
          if (currentTags === id) newChoosedBreakfastTags.push([id]);
        });
        choosedLunchTags.forEach((id) => {
          if (currentTags === id) newChoosedLunchTags.push([id]);
        });

        choosedDinnerTags.forEach((id) => {
          if (currentTags === id) newChoosedDinnerTags.push([id]);
        });
      });

      runGenerator(
        {
          breakfast: newChoosedBreakfastTags,
          morningSnack: [isMorningSnack ? [breakfastSnackId] : []],
          lunch: newChoosedLunchTags,
          afternoonSnack: [isAfternoonSnack ? [lunchSnackId] : []],
          dinner: newChoosedDinnerTags,
          eveningSnack: [isEveningSnack ? [dinnerSnackId] : []],
          id: currentUserId,
          ff_limit: +ffLimit,
          repeat: currentGenerationMode,
        },
        setIsGenerateRun,
      );
    };

    const onCreateUser = () => {
      createUser(
        {
          name: currentUserName,
          params: {
            sex_id: default_gender.indexOf(currentGender) + 1,
            height: currentHeight,
            weight: currentWeight,
            weight_target: currentTargetWeight,
            age: currentAge,
            activity_id: default_activity.indexOf(currentActivity) + 1,
          },
          tags: choosedTags,
          id: currentUserId,
        },
        setIsCreateUser,
      );
    };

    return (
      <React.Fragment>
        <Navbar />
        <H1>Страница клиентов</H1>
        <SearchInputBlock>
          {!isCreateUser && (
            <Dropdown
              placeholder="Выберите пользователя"
              fluid
              search
              selection
              options={usersList}
              onChange={(e, data) => onChangeUsers(e, data)}
            />
          )}
          {isCreateUser && (
            <Input
              placeholder="Введите имя нового клиента"
              style={{ width: '100%' }}
              value={currentUserName}
              onChange={(e) => setCurrentUserName(e.target.value)}
            />
          )}
          <CreateUserButton>
            <Button
              color="blue"
              onClick={() => {
                setIsCreateUser(!isCreateUser);
              }}
            >
              {!isCreateUser ? 'Создать нового клиента' : 'Вернутся к просмотру клиента'}
            </Button>
          </CreateUserButton>
        </SearchInputBlock>
        <UserParamsBlock
          allProductsTags={allTags}
          choosedTags={choosedTags}
          setChoosedTags={setChoosedTags}
          params={userTarget}
          currentGender={currentGender}
          setCurrentGender={setCurrentGender}
          currentActivity={currentActivity}
          setCurrentActivity={setCurrentActivity}
          currentHeight={currentHeight}
          setCurrentHeight={setCurrentHeight}
          currentWeight={currentWeight}
          setCurrentWeight={setCurrentWeight}
          currentAge={currentAge}
          setCurrentAge={setCurrentAge}
          currentTargetWeight={currentTargetWeight}
          setCurrentTargetWeight={setCurrentTargetWeight}
        />
        <TargetedFitnessFuncBlock params={userTarget} />
        <ButtonBlock>
          {!isCreateUser && (
            <Button positive onClick={onParamsSave}>
              Сохранить
            </Button>
          )}
          {isCreateUser && (
            <Button positive onClick={onCreateUser}>
              Создать клиента
            </Button>
          )}
        </ButtonBlock>
        <MenuStructureBlock
          isMorningSnack={isMorningSnack}
          setIsMorningSnack={setIsMorningSnack}
          isAfternoonSnack={isAfternoonSnack}
          setIsAfternoonSnack={setIsAfternoonSnack}
          isEveningSnack={isEveningSnack}
          setIsEveningSnack={setIsEveningSnack}
          choosedBreakfastTags={choosedBreakfastTags}
          setChoosedBreakfastTags={setChoosedBreakfastTags}
          choosedLunchTags={choosedLunchTags}
          setChoosedLunchTags={setChoosedLunchTags}
          choosedDinnerTags={choosedDinnerTags}
          setChoosedDinnerTags={setChoosedDinnerTags}
          match={match}
        />
        <GenerationModeBlock>
          <GenerationModeLabel>Выбор режима генерации</GenerationModeLabel>
          <Dropdown
            placeholder="Выберите режим генерации"
            fluid
            value={currentGenerationMode}
            selection
            style={{ width: '60%' }}
            options={defaultGenerationModes}
            onChange={(e, data) => setCurrentGenerationMode(data.value)}
          />
        </GenerationModeBlock>

        <FFLimitBlock>
          <FFLimitLabel>Лимит фитнес функции</FFLimitLabel>
          <Input
            placeholder="Введите лимит фф"
            type="number"
            style={{ width: '60%' }}
            value={ffLimit}
            onChange={(e) => setFfLimit(e.target.value)}
          />
        </FFLimitBlock>

        <ButtonBlock>
          <Button
            disabled={
              isGenerateRun ||
              !currentUser ||
              !choosedBreakfastTags.length ||
              !choosedLunchTags.length ||
              !choosedDinnerTags.length
            }
            loading={isGenerateRun}
            color="violet"
            onClick={onStartGeneration}
          >
            Cгенерировать меню!
          </Button>
        </ButtonBlock>
        <ResultBlock usersGeneratedData={usersGeneratedData} dishTags={allTags} />
        <FooterBlock />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const { allTags, usersGeneratedData, userTarget, users } = state.newYouslim;
  return {
    allTags,
    usersGeneratedData,
    userTarget,
    users,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProductTags: (tags) => {
      dispatch(action.getProductTags(tags));
    },
    getUsers: () => {
      dispatch(action.getUsers());
    },
    updateUser: (data, id) => {
      dispatch(action.updateUser(data, id));
    },
    setUserTarget: (data) => {
      dispatch(action.setUserTarget(data));
    },
    getGenetatorResults: (id) => {
      dispatch(action.getGenetatorResults(id));
    },
    runGenerator: (data, setIsGenerateRun) => {
      dispatch(action.runGenerator(data, setIsGenerateRun));
    },
    createUser: (data, setIsCreateUserPopup) => {
      dispatch(action.createUser(data, setIsCreateUserPopup));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);

//////ROUTE !!!!!!!!!!!!!!!!!!!!!



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TestPage/index.jsx